// extracted by mini-css-extract-plugin
export var arrows = "_5f-5";
export var decrementer = "_5f-9";
export var disabled = "_5f-3";
export var error = "_5f-1";
export var hiddenText = "_5f-a";
export var incrementer = "_5f-8";
export var input = "_5f-7";
export var inputWrapper = "_5f-0";
export var leadingIcon = "_5f-b";
export var readonly = "_5f-2";
export var regular = "_5f-6";
export var small = "_5f-4";